import { useState } from "react";
import { ArrowRight, Star, Calendar, Heart, MessageCircle, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import TrialSignupDialog from "@/components/TrialSignupDialog";
import DashboardPreview from "@/components/DashboardPreview";

export default function Hero() {
  const [trialOpen, setTrialOpen] = useState(false);

  return (
    <section className="relative overflow-hidden pt-16 sm:pt-24 pb-16 sm:pb-24">
      <div className="pointer-events-none absolute -top-32 -left-32 w-[520px] h-[520px] rounded-full bg-[#A8BFA3]/40 blur-3xl" />
      <div className="pointer-events-none absolute -top-24 right-0 w-[420px] h-[420px] rounded-full bg-[#F4B183]/30 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-6 sm:px-10 lg:px-16">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-6 rise-in">
            <div className="overline mb-6">Follow-ups on autopilot</div>
            <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight text-[#183D36] leading-[1.05]">
              Turn every visit into <span className="italic text-[#183D36]">the next one.</span>
            </h1>
            <p className="mt-6 text-lg sm:text-xl text-[#252525]/85 leading-relaxed max-w-xl">
              NextVisit sends the warm thank-yous, review requests, rebooking nudges, and win-back messages your team never has time for — so your calendar stays full without extra effort.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <Button
                data-testid="hero-start-free-btn"
                onClick={() => setTrialOpen(true)}
                className="rounded-full bg-[#183D36] hover:bg-[#122e29] text-[#FAF7F0] px-8 py-6 text-base font-medium shadow-lg hover:-translate-y-0.5 transition-all"
              >
                Start free — 14 days
                <ArrowRight className="ml-2" size={18} />
              </Button>
              <Button
                data-testid="hero-how-it-works-btn"
                variant="ghost"
                asChild
                className="rounded-full border border-[#183D36]/20 hover:bg-[#EFECE5] text-[#252525] px-8 py-6 text-base"
              >
                <a href="#how">See how it works</a>
              </Button>
            </div>

            <div className="mt-10 flex items-center gap-6 flex-wrap">
              <div className="flex items-center gap-3" data-testid="hero-founder-badge">
                <span className="w-11 h-11 rounded-2xl bg-[#183D36] text-[#F4B183] flex items-center justify-center">
                  <Heart size={16} strokeWidth={2} />
                </span>
                <div className="text-sm text-[#4A4A4A] leading-tight">
                  <div className="font-medium text-[#252525]">Built by an operator, for operators.</div>
                  <span className="text-xs">Founding customers get direct-line support from Brooke.</span>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-6 rise-in" style={{ animationDelay: '0.15s' }}>
            <DashboardPreview />
          </div>
        </div>
      </div>

      <TrialSignupDialog open={trialOpen} onOpenChange={setTrialOpen} />
    </section>
  );
}
